module.exports = __webpack_public_path__ + "static/media/dashboard_shape.adc70f18.svg";